var $0993ddf5b2ce32c5$exports = {};
$0993ddf5b2ce32c5$exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};


export {$0993ddf5b2ce32c5$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
